import * as React from 'react';
import { ErrorBoundary } from '@zardoy/react-util';
import { showNotification } from '../react/NotificationProvider';
const injectUiPlaces = [
    'root',
    'button',
    'mainMenu',
    'mainMenuProvider',
    'chat',
    'chatProvider',
    'addServerOrConnect',
    'armorBar',
    'bossBarOverlay',
    'createWorld',
    'singleplayer',
    'deathScreen',
    'debugOverlay',
    'fullmap',
    'input',
    'notification',
    'optionsItems',
    'title',
    'slider',
    'serversList',
    'scoreboard',
    'select',
    'screen',
    'screenDirtBg',
    'appStatus',
    'appStatusProvider',
    'diveTransition',
];
const wrapWithErrorBoundary = (Component, props, index, place) => {
    return (<ErrorBoundary key={index} renderError={(error) => {
            const componentName = Component.name || Component.displayName || 'Unknown';
            showNotification(`Registered component ${place} crashed: ${componentName}`, `Use console for more. ${error.message}`, true, undefined);
            return null;
        }}>
      <Component {...props}/>
    </ErrorBoundary>);
};
export const withInjectableUi = (Component, place) => {
    const placeUppercaseFirst = place.charAt(0).toUpperCase() + place.slice(1);
    window.builtinOriginalComponents ??= {};
    window.builtinOriginalComponents[placeUppercaseFirst] = Component;
    const WrappedComponent = (props) => {
        const components = Object.values(window.mcraft?.ui?.registeredReactWrappers?.[place] || {});
        // Start with the original component as the innermost
        let wrapped = <Component {...props}/>;
        // Wrap with registered components in reverse order
        // First registered component wraps last registered component, which wraps the original
        // e.g., if [A, B] are registered: A wraps B, B wraps Component
        for (let i = components.length - 1; i >= 0; i--) {
            const WrapperComponent = components[i];
            wrapped = wrapWithErrorBoundary(WrapperComponent, { ...props, children: wrapped }, i, place);
        }
        return <>{wrapped}</>;
    };
    WrappedComponent.displayName = `withInjectableUi(${Component.displayName || Component.name || 'Component'}, ${place})`;
    window.builtinComponents ??= {};
    window.builtinComponents[placeUppercaseFirst] = WrappedComponent;
    return WrappedComponent;
};
